import { UseQueryResult } from '@tanstack/react-query';
import { useEffect, useRef } from 'react';
import { useAuth } from 'react-oidc-context';
import { UserPopulatedDTO, UserService } from '../api/generated';
import { useUser } from '../api/queries/user';

export function useCurrentUser(): UseQueryResult<UserPopulatedDTO, Error> {
  const { user: authUser } = useAuth();
  const sub = authUser?.profile.sub;

  const query = useUser({ authId: sub });
  const { data: user } = query;

  const notifiedSub = useRef<string | undefined>(undefined);
  useEffect(() => {
    if (!user || !sub || notifiedSub.current === sub) return;
    notifiedSub.current = sub;
    UserService.userControllerLoginUser().catch((err) => {
      console.error('Failed to call loginUser:', err);
    });
  }, [user, sub]);

  return query;
}
